module.exports = __webpack_public_path__ + "static/img/20211115.4f4cc57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/20211115.jpg
// module id = SlPr
// module chunks = 96